import { defineStore } from "pinia";
import { ref } from "vue";
import { Country } from "@/types/countryType";

export const useCountryTypesStore = defineStore(
  "countryType",
  () => {
    const countryTypes = ref<Country[]>([]);
    const selectedCountry = ref<Country | null>(null);

    // Actions
    function setCountryTypes(types: Country[]) {
      countryTypes.value = types;
    }

    function clearCountryTypes() {
      countryTypes.value = [];
      selectedCountry.value = null;
    }

    function setSelectedCountry(country: Country | null) {
      selectedCountry.value = country;
    }

    function getCountryTypes(): Country[] {
      return countryTypes.value;
    }

    return {
      countryTypes,
      selectedCountry,
      setCountryTypes,
      clearCountryTypes,
      setSelectedCountry,
      getCountryTypes,
    };
  },
  {
    persist: true,
  }
);
